/** Foot pivots use the principal connected silhouette, never stray export pixels. */
export function measureFootPivots(image: HTMLImageElement, columns: number, rows: number): number[] {
  const canvas = document.createElement('canvas'); canvas.width = image.width; canvas.height = image.height;
  const ctx = canvas.getContext('2d', { willReadFrequently: true })!; ctx.drawImage(image, 0, 0);
  const rgba = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
  const w = image.width / columns, h = image.height / rows;
  const anchors: number[] = [];
  for (let row = 0; row < rows; row++) for (let col = 0; col < columns; col++) {
    const seen = new Uint8Array(w * h), queue = new Int32Array(w * h);
    let largest = 0, floor = h - 4;
    const opaque = (x: number, y: number): boolean => rgba[((row * h + y) * image.width + col * w + x) * 4 + 3] >= 128;
    for (let start = 0; start < w * h; start++) {
      const sx = start % w, sy = Math.floor(start / w);
      if (seen[start] || !opaque(sx, sy)) continue;
      let head = 0, tail = 1, bottom = sy; queue[0] = start; seen[start] = 1;
      while (head < tail) {
        const at = queue[head++], x = at % w, y = Math.floor(at / w); bottom = Math.max(bottom, y);
        for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) {
          const nx = x + dx, ny = y + dy, next = ny * w + nx;
          if (nx < 0 || nx >= w || ny < 0 || ny >= h || seen[next] || !opaque(nx, ny)) continue;
          seen[next] = 1; queue[tail++] = next;
        }
      }
      if (tail > largest) { largest = tail; floor = bottom; }
    }
    anchors.push((h - 1 - floor) / h);
  }
  return anchors;
}
